//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
import Header from '../header'
import GQL from './gql'

export default {
  components: {
    Header
  },

  apollo: {
    service: GQL.service
  },

  data() {
    return {
      service: null
    }
  },

  computed: {
    title() {
      //;`${record.product ? record.product.service_reference : ''}${record.id}`

      if (
        !this.service?.product?.service_reference ||
        (this.service.product.id !== '7' && !this.service?.plan?.speed)
      ) {
        return ''
      }

      let serviceDescription =
        this.service.product.id === '7'
          ? `${this.service.subnet_size} Subnet`
          : this.service.plan
          ? `${this.service.plan.speed}Mbps ${
              this.service.product ? this.service.product.product_reference : ''
            }`
          : ''

      return `
        ${this.service.product.service_reference}${this.service.id} - ${serviceDescription}
      `
    },

    subtitle() {
      return this.service?.location?.premise?.address || ''
    }
  },

  methods: {
    backToSearch() {},
    ...mapMutations('service', ['STORE_SERVICE'])
  }
}
